import colors from '../../../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        button: {
            '&.MuiButton-root': {
                alignItems: 'center',
                backgroundColor: '#FEDF01',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: colors[mode].primaryText,
                display: 'flex',
                flexDirection: 'column',
                height: '40px',
                justifyContent: 'center',
                marginTop: theme.spacing(2),
                padding: '8px 16px'
            }
        },
        buttonContainer: {
            display: 'flex',
            padding: theme.spacing(3, 0, 3, 0)
        },
        buttonLogin: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                border: '1px solid #FEDF01',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '40px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                textTransform: 'uppercase',
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)'
            }
        },
        childrenContainer: {
            '& > form': {
                display: 'flex',
                flex: '1',
                height: 'auto',
            },
            display: 'flex',
            flex: '1',
            height: '100%',
            padding: '0px'
        },
        contentContainer: {
            borderRadius: '3px',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        },
        gridContainerCenter: {
            backgroundColor: colors[mode].cardContent,
            display: 'flex',
            justifyContent: 'center',
        },
        gridContainerCenterNew: {
            backgroundColor: colors[mode].secondaryBackground,
            display: 'flex',
            justifyContent: 'center',
        },
        helpText: {
            color: 'grey',
            fontSize: '12px',
            fontStyle: 'italic'
        },
        logo: {
            width: '176px;',
        },
        noAccessRoot: {
            padding: theme.spacing(12, 4, 4, 4)
        },
        rbccmOnline: {
            color: '#006AC3',
            fontSize: '20px',
            fontWeight: '500',
            height: '24px',
            letterSpacing: '0',
            lineHeight: '24px',
            width: '136px'
        },
        rbccmOnlineContainer: {
            display: 'flex',
            flexDirection: 'column',
            height: '33px',
            justifyContent: 'space-between',
            width: '136px',
        },
        rbccmOnlineDivider: {
            backgroundColor: '#FFC72C',
            height: '3px',
            width: '40px'
        },
        registrationContainer: {
            '@media screen and (max-width: 320px)': {
                minHeight: '40vh',
                padding: '0px'
            },
            borderRadius: '8px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '55vh',
            padding: '32px'
        },
        title: {
            color: 'rgba(0,0,0,0.87)',
            fontSize: '32px',
            fontWeight: '300',
            letterSpacing: '0',
            lineHeight: '38px',
            whiteSpace: 'pre-line'
        },
        verbiage: {
            color: 'rgba(0,0,0,0.54)',
            fontSize: '16px',
            fontWeight: '300',
            letterSpacing: '0',
            lineHeight: '24px',
            paddingTop: '16px',
            whiteSpace: 'pre-line'
        }
    }}

export default styles